/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import Draggable from 'react-draggable';

import { Paper, Typography, Button, TextField, IconButton } from '@material-ui/core'
import { Clear } from '@material-ui/icons';

import FieldTable from '../Fields/FieldTable';
import { classes } from 'istanbul-lib-coverage';


const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    handle : {}
})

const new_group = {
    group_id : null,
    fields : []
}

class NewGroup extends Component {
    state = {
        name : "",
        fields : []
    }

    getFields = () => {
        let fields = this.props.new_group.fields.map((field_data, i) => {
            let field_obj = {
                ...field_data.field_data,
                location : field_data.location
            }

            return field_obj
        })

        return fields
    }

    // renderName = () => {
    //     return (
    //         <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', backgroundColor : '#FFFFFF'}}>
    //             <TextField
    //                 fullWidth
    //                 label = "Group Name"
    //                 variant = 'outlined'
    //                 size = 'small'
    //             />
    //         </div>
    //     )
    // }

    renderFields = () => {
        const columns = ["$icon", "Name", "$options"]
        return (
            <div style = {{width : '100%', height : (this.props.space_height - 50) + "px", backgroundColor : 'rgba(245, 245, 245, 0.9)'}}>
                <div
                    style = {{
                        width : '100%',
                        height : '50px',
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        padding : '10px',
                        borderBottom : '1px solid rgba(0,0,0,0.12)',
                        backgroundColor : 'rgba(245, 245, 245, 1.0)'
                    }}
                >
                    <Typography variant = 'subtitle2'>Fields</Typography>
                </div>
                <div
                    style = {{
                        width : '100%',
                        height : (this.props.space_height - 100) + "px",
                        padding : '10px'
                    }}
                >
                    <FieldTable
                        columns = {columns}
                        group_data = {this.props.new_group}
                        body_height = {this.props.space_height - 150}
                        top_margin = "10px"
                        fields = {this.getFields()}
                        location = {'NewGroup'}
                        field_in_focus = {this.props.field_in_focus}
                        focus_field = {(field_object, field_type) => {
                            console.log("Selecting Field Type :", field_type)
                            if (field_object.group_id !== 'singletons') {
                                this.props.focus_field(field_object, field_type)
                            }
                        }}
                        accept_field_drops = {this.props.accept_field_drops}
                        field_type = {'field'}
                        move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                        syncing_field = {this.props.syncing_field}
                        column_index = {null}
                        unfocus_field = {() => this.props.focus_field(null, null)}
                        unsynced_fields = {this.props.unsynced_fields}
                        remove_field = {(field) => this.props.remove_field(field)}
                        group_filter = {this.props.group_filter}
                        update_filter = {(group_filter) => this.props.update_filter(group_filter)}
                    />
                </div>
            </div>
        )
    }

    handleNameChange = (event) => {
        this.setState({...this.state, name : event.target.value})
    }

    render() { 
        return (
            <Draggable
                axis = "x"
                bounds = 'parent'
                handle = '.handle'
            >
                <Paper
                    square
                    elevation = {6}
                    style = {{
                        position : 'fixed',
                        top : '98px',
                        left : '25vw',
                        width : '25vw',
                        height : this.props.space_height,
                        zIndex : 13,
                        backgroundColor : 'rgba(255,255,255, 0)'
                    }}
                >
                    <Paper 
                        className = "handle"
                        square
                        elevation = {0}
                        style = {{
                            width : '100%', 
                            height :'50px',
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            padding : '10px',
                            borderBottom : '1px solid rgba(0,0,0,0.12)',
                            cursor : 'move'
                        }}
                    >
                        <ThemeProvider theme = {blue_theme}>
                            <IconButton color = 'secondary' size = 'small' onClick = {this.props.close_new_group}>
                                <Clear fontSize = 'inherit'/>
                            </IconButton>
                        </ThemeProvider>
                        {/* <Typography style = {{marginLeft : '10px', flexGrow : 1}} variant = 'subtitle2'>New Group</Typography> */}
                        <div style = {{marginLeft : '10px', padding : '5px', flexGrow : 1, width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <TextField
                                style = {{flexGrow : 1}}
                                variant = 'outlined'
                                size = 'small'
                                label = "Group Name"
                                placeholder = "New Group"
                                value = {this.state.name}
                                fullWidth
                                onChange = {this.handleNameChange}
                                error = {this.props.new_group_error}
                            />
                        </div>
                        <ThemeProvider theme = {blue_theme}>
                            <Button
                                variant = 'contained'
                                color = 'primary'
                                size = 'small'
                                disabled = {this.props.new_group.fields.length < 2}
                                onClick = {() => this.props.create_new_group(this.state.name)}
                            >
                                Submit
                            </Button>
                        </ThemeProvider>
                    </Paper>
                    {this.renderFields()}
                </Paper>
            </Draggable>
        );
    }
}
 
export default withStyles(styles)(NewGroup);